<modal-panel [title]="title" (close)="closeDialog()" id="agent-info-modal-panel">
  <ng-container id="agent-viewer-modal-agent-container">
    <agent-details [data]="data.agentData"></agent-details>
  </ng-container>

  <ng-container modalPanelFooter id="agent-info-modal-footer">
    <button mat-raised-button color="primary" (click)="closeDialog()" id="agent-info-modal-close-button">Close</button>
  </ng-container>
</modal-panel>
